"use client";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { IconButton } from "@mui/material";
import { Share as ShareIcon } from "@mui/icons-material";

import { useStore } from "../../service/mobx";

export default function ShareButton() {
  const [show, setShow] = useState(false);
  const { analytics, reader, snackbar } = useStore();
  const url = usePathname();

  useEffect(() => {
    setShow(
      reader.whiteLabelled === false &&
        (!!navigator.share || !!navigator.clipboard)
    );
  }, [reader.whiteLabelled]);

  return show ? (
    <IconButton
      aria-label="Share"
      onClick={() => {
        if (navigator.share) {
          navigator.share({ url });
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(location.toString());
          snackbar.notify({ text: "Copied URL to clipboard" });
        }
        analytics.track.event("Share Click", { url });
      }}
    >
      <ShareIcon sx={{ color: "surface.on.variant" }} />
    </IconButton>
  ) : null;
}
